import type { CSSProperties } from "react";

// CSS-only overlay: iOS Safari never resolves requestFullscreen() on an iframe.
const fullscreenStyle = (isFullscreen: boolean): CSSProperties | undefined => {
  if (!isFullscreen) return undefined;
  return {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100svw",
    height: "100svh",
    zIndex: 998,
  };
};

export default fullscreenStyle;
